var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.layers),function(layer){return _c('div',{key:layer.zone,staticClass:"covering-zone-band",style:(_vm.bandStyle(layer))})}),_vm._l((_vm.layers),function(layer){return _c('CoveringZoneBadge',{key:`${layer.zone}-label`,staticClass:"covering-zone-chip",style:(_vm.chipStyle(layer)),attrs:{"zone":layer.zone,"on-media":""}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }